import Place from './Place.js'
import PlaceMap from './PlaceMap.js'
import PlaceFilter from './PlaceFilter.js'

export default class Places {
  constructor() {
    this.el = document.getElementById('places-map')

    if (this.el) {
      this.places = []

      this.infoWindowTriggers = document.querySelectorAll(
        '.js-place-info-window-trigger',
      )

      this.infoWindowTriggers.forEach((element) => {
        const instance = new Place(element)
        this.places.push(instance)
      })

      this.map = new PlaceMap(this.el, this.places)

      this.filters = document.querySelectorAll('.js-place-filter')
      this.filters.forEach((element) => new PlaceFilter(element, this.el))
    }
  }
}
